import { Component } from 'react';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { IGNORE_ERRORS, SENTRY_KEYS } from 'framework-listing-lib/utils/sentry';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
    this.componentDidCatch = (error, errorInfo) => {
      if (typeof (error === null || error === void 0 ? void 0 : error.message) === 'string' && Object.values(IGNORE_ERRORS).some(ignoreMessage => ignoreMessage.includes(error.message))) {
        return;
      }
      Raven.captureException(error, {
        extra: {
          errorInfo,
          componentStack: errorInfo.componentStack,
          error
        },
        fingerprint: [this.props.fingerprint],
        tags: {
          lib: 'framework-listing-lib'
        }
      });
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  getTitle() {
    switch (this.props.fingerprint) {
      default:
        return '';
      case SENTRY_KEYS.CRM_LISTING_FOLDERS:
        return 'frameworkListingLib.error.foldersError.title';
    }
  }
  getErrorMessageKey() {
    switch (this.props.fingerprint) {
      default:
        return 'frameworkListingLib.error.generalError.message';
      case SENTRY_KEYS.CRM_LISTING_FOLDERS:
        return 'frameworkListingLib.error.foldersError.message';
    }
  }
  render() {
    const {
      hasError
    } = this.state;
    if (!hasError) {
      return this.props.children || null;
    }
    if (this.props.errorComponent) {
      return this.props.errorComponent;
    }
    const uiErrorTitle = this.getTitle();
    const uiErrorMessage = this.getErrorMessageKey();
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      "data-test-id": "crm-listing-error-boundary",
      title: uiErrorTitle && /*#__PURE__*/_jsx(FormattedMessage, {
        message: uiErrorTitle
      }),
      type: "badRequest",
      children: uiErrorMessage && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: uiErrorMessage
        })
      })
    });
  }
}
export default ErrorBoundary;